import { NotificationStatus } from '@/enums/components/general/NotificationStatus'
import { NotificationPosition } from '@/enums/components/general/NotificationPosition'
import router from '@/router'
import { INotification } from '@/interfaces/components/general/INotification'
import { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig } from 'axios'

interface LoadingSpinnerStoreInstance {
  startLoading?: (key: string) => void;
  stopLoading?: (key: string) => void;
  stopAllLoading?: () => void;
}

interface NotificationStoreInstance {
  addNotification: (notification: INotification) => void;
}

export const crashManager = (
  error: string,
  notificationStoreInstance: NotificationStoreInstance, // Aggiunto parametro
  loadingSpinnerStoreInstance: LoadingSpinnerStoreInstance // Aggiunto parametro per coerenza
) => {
  notificationStoreInstance.addNotification({
    title: 'Errore dell\'applicativo',
    message: 'Abbiamo riscontrato qualche errore. Verrai reindirizzato alla home.',
    status: NotificationStatus.ERROR,
    position: NotificationPosition.TOP,
    timeout: 1500,
    dismissable: true,
    afterDismissCallback: () => {
      console.error(error)
      loadingSpinnerStoreInstance.stopAllLoading?.() // Usa l'istanza passata
      router.push('/')
    }
  } as INotification)
}

function getJsonObj(input:  | any): any | undefined {
  try {
    return JSON.parse(input)
  } catch (e) {
    return input
  }
}

function getKeyRequest(request: InternalAxiosRequestConfig): string {
  try {
    const key = `${request.url}${JSON.stringify(request.params ?? '')}${JSON.stringify(getJsonObj(request.data) ?? '')}`
    return clearString(key)
  } catch (e) {
    return clearString(`${request.url}`)
  }
}

function clearString(text: string): string {
  const utf8Bytes = new TextEncoder().encode(text)
  return btoa(String.fromCharCode(...utf8Bytes))
}

export function setupCommonInterceptors(
  axiosInstance: AxiosInstance,
  loadingSpinnerStoreInstance: LoadingSpinnerStoreInstance, // Aggiunto parametro
  notificationStoreInstance: NotificationStoreInstance // Aggiunto parametro
) {
  axiosInstance.interceptors.request.use(function(config: InternalAxiosRequestConfig) {
    loadingSpinnerStoreInstance.startLoading?.(getKeyRequest(config))
    return config
  }, function(error: AxiosError) {
    if (error.config?.url !== undefined) {
      loadingSpinnerStoreInstance.stopLoading?.(getKeyRequest(error.config))
    } else {
      crashManager(error.message, notificationStoreInstance, loadingSpinnerStoreInstance)
    }

    return Promise.reject(error)
  })

  axiosInstance.interceptors.response.use((response: AxiosResponse) => {
    loadingSpinnerStoreInstance.stopLoading?.(getKeyRequest(response.config))
      return response
    }, (error: AxiosError) => {
      if (error.config?.url !== undefined) {
        loadingSpinnerStoreInstance.stopLoading?.(getKeyRequest(error.config))
      } else {
        crashManager(error.message, notificationStoreInstance, loadingSpinnerStoreInstance)
      }
      return Promise.reject(error)
    }
  )
}

export default {
  setupCommonInterceptors,
  crashManager
}